'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _forgotPasswordForm = require('./forgot-password-form');

var _forgotPasswordForm2 = _interopRequireDefault(_forgotPasswordForm);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ForgotPasswordModal = _react2['default'].createClass({
    displayName: 'ForgotPasswordModal',


    propTypes: {
        'tabOffset': _react2['default'].PropTypes.number,
        'recoverPasswordForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
        'emailAddress': _react2['default'].PropTypes.string
    },

    getInitialState: function getInitialState() {
        return {};
    },
    componentDidMount: function componentDidMount() {
        if (process.env.NODE_ENV !== 'test') {
            $(document).foundation();
            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
        }
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
        if (process.env.NODE_ENV !== 'test') {
            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
        }
    },
    render: function render() {

        var form = _react2['default'].createElement(_forgotPasswordForm2['default'], {
            tabOffset: this.props.tabOffset,
            method: 'POST',
            namespace: this.props.recoverPasswordForm.namespace,
            action: _hfReactHelper2['default'].urlHelper('account/recoverPassword', _hfReactHelper2['default'].HfSites.SITE_CODE_HS),
            fields: this.props.recoverPasswordForm.fields,
            values: this.props.recoverPasswordForm.values,
            emailAddress: this.props.emailAddress,
            errors: { 'global': this.state.error } });

        return _react2['default'].createElement(
            'div',
            { className: 'row text-center' },
            _react2['default'].createElement(
                'div',
                { className: 'columns small-12' },
                _react2['default'].createElement(
                    'h4',
                    null,
                    'No worries.'
                ),
                _react2['default'].createElement(
                    'p',
                    { className: 'l-padding-b-10' },
                    'Enter your email address to request a password reset.',
                    _react2['default'].createElement('br', null)
                ),
                form
            )
        );
    }
});

module.exports = ForgotPasswordModal;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/forgot-password-modal.jsx
 ** module id = 878
 ** module chunks = 0
 **/